const BaseClass = require('components/BaseClass/BaseClass');
const React = require('react');
const ReduxProvider = require('utils/framework/ReduxProvider');
const wrapUFE = require('utils/framework/wrapUFE');


const wrapWithProvider = WrappedComponent => {
    class WithProvider extends BaseClass {
        static class = 'WithReduxProvider';
        static displayName = `withReduxProvider(${WrappedComponent.displayName || WrappedComponent.class})`

        render() {
            const {
                children, ...props
            } = this.props;

            return (
                <ReduxProvider>
                    <WrappedComponent {...props}>
                        {children}
                    </WrappedComponent>
                </ReduxProvider>
            );
        }
    }

    if (WrappedComponent.prototype?.renderOnLoadEvent) {
        WithProvider.prototype.renderOnLoadEvent = WrappedComponent.prototype.renderOnLoadEvent;
    }

    return wrapUFE(WithProvider);
};

module.exports = wrapWithProvider;
